import { createReducer, on } from '@ngrx/store';
import * as settingsActions from './settings.actions';
import { RoleDto, UserDto } from './settings.dtos';


export interface RoleState {
  createRoleLoading: boolean;
  updateRoleLoading: boolean;

  allUserRoles: any[] | null;
  rolesError: boolean;
  rolesLoading: boolean;

  allSystemUsers: UserDto[] | null;
  usersError: boolean;
  usersLoading: boolean;
}


export const initialState: RoleState = {
  createRoleLoading: false,
  updateRoleLoading: false,

  allUserRoles: null,
  rolesError: null,
  rolesLoading: null,

  allSystemUsers: null,
  usersError: null,
  usersLoading: null
};

export const RolesReducer = createReducer(
  initialState,

  on(settingsActions.createRole, (state) => ({
    ...state,
    createRoleLoading: true
  })),

  on(settingsActions.createRoleSuccess, (state) => ({
    ...state,
    createRoleLoading: false
  })),

  on(settingsActions.createRoleFailed, (state) => ({
    ...state,
    createRoleLoading: false
  })),

  on(settingsActions.fetchRoles, (state) => ({
    ...state,
    allUserRoles: null,
    rolesError: null,
    rolesLoading: true
  })),

  on(settingsActions.fetchRolesSuccess, (state, { allRoles }) => ({
    ...state,
    allUserRoles: allRoles,
    rolesError: false,
    rolesLoading: false
  })),

  on(settingsActions.fetchRolesFailed, (state) => ({
    ...state,
    allUserRoles: null,
    rolesError: true,
    rolesLoading: false
  })),

  on(settingsActions.fetchUsers, (state) => ({
    ...state,
    allSystemUsers: null,
    usersError: null,
    usersLoading: true
  })),

  on(settingsActions.fetchUsersSuccess, (state, { allUsers }) => ({
    ...state,
    allSystemUsers: allUsers,
    usersError: false,
    usersLoading: false
  })),

  on(settingsActions.fetchUsersFailed, (state) => ({
    ...state,
    allSystemUsers: null,
    usersError: true,
    usersLoading: false
  }))
);